"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c79cb6405{width:100%;border-spacing:0 .0625rem}.c79cb6405 th{text-align:left;font-size:.875rem;font-weight:500;line-height:1rem;padding:1.1875rem .9375rem .8125rem 1.625rem}.c79cb6405 th:first-child{border-top-left-radius:var(--border-radius-def)}.c79cb6405 th:last-child{border-top-right-radius:var(--border-radius-def)}.c79cb6405 tbody{background:#fff}.c79cb6405 td{font-size:1rem;font-weight:400;line-height:1.125rem;padding:1.0625rem .9375rem 1.0625rem 1.625rem}.c79cb6405 tr:last-child td:first-child{border-bottom-left-radius:var(--border-radius-def)}.c79cb6405 tr:last-child td:last-child{border-bottom-right-radius:var(--border-radius-def)}.c6faba859 thead{background:var(--color-flomni-bg-3)}.cc6e9aa66 thead{background:0 0}");
var styles = {
  root: 'c79cb6405',
  '--view-usual': 'c6faba859',
  '--view-headless': 'cc6e9aa66'
};

var Table = function Table(props) {
  var children = props.children,
      view = props.view,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, children);
};

exports.Table = Table;
var view = ['usual', 'headless'];
Table.modes = {
  view: view
};
Table.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Table.defaultProps = {
  view: 'usual',
  classes: {}
};